import { AccordionItem, Accordion } from "../Accordion/Accordion";
import { Row, Col, Container } from "reactstrap";
import styles from "./ResourcesBody.module.scss";
import Tags from "../Tags/Tags";

const ResourcesBody = ({ headline, takeaways, actions }) => {
  const { locations, concerns, outcomes } = window?._edo_settings?.publication || {};
  const tags = [...(locations || []), ...(concerns || []), ...(outcomes || [])].filter(tag => !!tag);
  const takeawaysDangerouslySetInnerHTML = typeof takeaways === 'string' ? { __html: takeaways } : undefined
  const actionsDangerouslySetInnerHTML = typeof actions === 'string' ? { __html: actions } : undefined

  return (
    <Container>
      <div className={styles.containerResourcesBody}>
        <Row className={`${styles.containerTop} py-5`}>
          <Col className={styles.colStart} xs={12} lg={5}>
            <h4>{headline}</h4>
            <Accordion>
              <AccordionItem heading="Key takeaways">
                <div className={styles.summaryItem} dangerouslySetInnerHTML={takeawaysDangerouslySetInnerHTML}>
                  {typeof takeaways !== 'string' ? takeaways : null}
                </div>
              </AccordionItem>
              <AccordionItem heading="Key actions">
                <div className={styles.summaryItem} dangerouslySetInnerHTML={actionsDangerouslySetInnerHTML}>
                  {typeof actions !== 'string' ? actions : null}
                </div>
              </AccordionItem>
            </Accordion>
          </Col>
          <Col xs={12} className={styles.colEnd} lg={{ offset: 1, size: 6 }}>
            <Tags tags={tags} />
          </Col>
        </Row>
      </div >
    </Container>
  );
}
export default ResourcesBody;
